import { useSelector } from 'react-redux';
import { ChevronLeftIcon } from '../../components/ui/icons';
import { ListingHeaderActions } from '../../components/features/listings/ListingHeaderActions';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import * as styles from './desktopStickyHeader.styles';

type DesktopStickyHeaderProps = {
  onBack: () => void;
};

export const DesktopStickyHeader = ({ onBack }: DesktopStickyHeaderProps) => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails.currentListing);
  const listingName =
    (listing as unknown as { propertyName?: string })?.propertyName ||
    (listing as unknown as { displayName?: string })?.displayName ||
    listing?.address?.street ||
    '';

  return (
    <header className={styles.desktopHeader}>
      <div className={styles.desktopHeaderColumns}>
        <div className={styles.desktopHeaderLeft}>
          <button className={styles.backButton} onClick={onBack} aria-label="Back to search results">
            <ChevronLeftIcon />
            <span>Back to search</span>
          </button>
        </div>

        <div className={styles.desktopHeaderCenter}>
          <h2 className={styles.listingName}>{listingName}</h2>
        </div>

        <div className={styles.desktopHeaderRight}>
          <ListingHeaderActions size="sm" showCTAs />
        </div>
      </div>
    </header>
  );
};
